import groupBy from 'ramda/src/groupBy';
import sum from 'ramda/src/sum';
import { useMemo } from 'react';
import type { DistrictBreakdownTableRow, MKEERAApiResponseItem } from '../dashboard.types';
import { formatDistrict, parseAmount } from '../utils/dataProcessing';

export function useDistrictBreakdownTableData(data: MKEERAApiResponseItem[]): DistrictBreakdownTableRow[] {
  return useMemo(() => {
    // Safety check: ensure data is an array
    if (!Array.isArray(data) || data.length === 0) {
      return [];
    }

    // Group by district number (as string)
    const grouped = groupBy((item: MKEERAApiResponseItem) => formatDistrict(item.applicationData.aldermanicDistrict), data);

    // Create all 15 districts (1-15)
    const allDistricts: DistrictBreakdownTableRow[] = [];

    for (let i = 1; i <= 15; i++) {
      const districtKey = i.toString();
      const districtData = grouped[districtKey] || [];
      const safeRows = Array.isArray(districtData) ? districtData : [];

      // Only count rows with a valid district
      const validRows = safeRows.filter((item) => item.applicationData.aldermanicDistrict);

      allDistricts.push({
        district: districtKey,
        totalHouseholds: validRows.length,
        totalDisbursed: sum(validRows.map((item) => parseAmount(item.applicationData.amountOfPayment))),
      });
    }

    return allDistricts;
  }, [data]);
}
